import React from "react";

/* eslint-disable max-len */
export default function ContentsCountIcon() {
    return (
        <svg version="1.1" id="icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 32 25.8" enableBackground="new 0 0 32 25.8" xmlSpace="preserve">
		<path fill="#AAAAAA" d="M24.6,1.5l2.9,5.7h-4.3l-2.9-5.7h-2.9l2.9,5.7H16l-2.9-5.7h-2.9l2.9,5.7H8.9L6,1.5H4.6
			C3,1.5,1.8,2.8,1.8,4.3l0,17.1c0,1.6,1.3,2.9,2.9,2.9h22.8c1.6,0,2.9-1.3,2.9-2.9v-20H24.6z"/>
		</svg>
    );
}
